import { t } from 'i18next';
import { TyreRepairOptions } from '../Constants/Common';

export class TranslationHelper {
    static getTranslatedText = (panel: string, section?: string): string => {
        if (panel) {
            const resourceKey = panel.toLowerCase().replaceAll(/[\W_]/g, '_');

            if (section) return t(`${section}.${resourceKey}`);
            else return t(resourceKey);
        } else return '';
    };

    static getTranslatedRepairOption = (option: string): string => {
        switch (option) {
            case TyreRepairOptions.Dealer:
                return t('tyre_repair_request.repair_option_1');
            case TyreRepairOptions.KwikFit:
                return t('tyre_repair_request.repair_option_2');
            case TyreRepairOptions.PreferredGarage:
                return t('tyre_repair_request.repair_option_3');
            default:
                return option;
        }
    };
}
